module.exports = __webpack_public_path__ + "img/green_plane.2f4ec5b3.svg";